import { TablePagination } from '@/components/sv/table-pagination'

type Props = {
  total: number
  offset: number
  limit: number
  handlePagination: (pagination: { offset: number; limit: number }) => void
}

export const TableBackendPagination = ({
  total,
  limit,
  offset,
  handlePagination,
}: Props) => {
  return (
    <TablePagination
      pageCount={Math.ceil(total / limit)}
      currentPage={Math.ceil(offset / limit) + 1}
      pageSize={limit}
      setPageSize={(value) => {
        const newLimit = Number(value)
        handlePagination({ offset: 0, limit: newLimit })
      }}
      canPreviousPage={offset !== 0}
      canNextPage={offset + limit < total}
      firstPage={() => handlePagination({ offset: 0, limit })}
      previousPage={() => handlePagination({ offset: offset - limit, limit })}
      nextPage={() => handlePagination({ offset: offset + limit, limit })}
      lastPage={() =>
        handlePagination({
          offset: (Math.ceil(total / limit) - 1) * limit,
          limit,
        })
      }
    />
  )
}
